import gql from 'graphql-tag';

export default gql`
  fragment renovationHouseFormValues on RenovationHouseFormValues {
    house_area
    solar_power_size_kwp
    number_of_floors
    new_windows_number
    number_of_lift_and_slide_doors
    number_of_extra_large_windows
    renovation_walls_and_interior_doors_area
    new_flooring_area
    sanitary_renovation_area
    number_of_bathrooms_for_renovation
    number_of_toilets_for_renovation
    facade_insulation_type
    facade_insulation_area
    renewal_of_front_door
    roof_renewal_type
    roof_renewal_area
    heating_system_for_renovation
    insulation_top_ceiling_area
    insulation_basement_ceiling_area
    number_of_interior_doors_for_renovation
    hot_water_with_new_heating_system

    other_investments_amount
    other_investments_comment

    domestic_ventilation_equipment_type
    carport_equipment_type
    garage_equipment_type
    alarm_system_equipment_type
    facade_insulation_equipment_type
    roof_renewal_equipment_type
    solar_power_equipment_type
    kitchen_equipment_type
    air_condition_equipment_type
    sanitary_renovation_equipment_type
    new_flooring_equipment_type
    renovation_walls_and_interior_doors_equipment_type
    renewal_of_electric_installation_equipment_type
    renewal_of_front_door_equipment_type
    new_windows_equipment_type
    renewal_of_heating_system_equipment_type
    pool_equipment_type
    winter_garden_equipment_type
  }
`;
